import React, { Component, ComponentType } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { DataManager, Query } from '@syncfusion/ej2-data';
import { RootState } from '../../store';
import { ILinkedinDetailsContainerStateProps, ILinkedinDetailsContainerDispatchProps } from '../../interfaces/props/ILinkedinDetailsProps';
import * as linkedinDetailsStore from '../../store/modules/linkedinDetails.store';
import { URL } from '../../common/constants';
import { IMyRule } from '../../common/model/myRule.model';
import { RuleCondition } from '../../common/model/enumerations/ruleCondition.model';
import { RuleOperator } from '../../common/model/enumerations/ruleOperator.model';
import { dataManagerService, oDataService, queryBuilderService } from '../../services';
import Linkedin from './linkedin/linkedin';
import { ILinkedin } from '../../common/model/linkedin.model';
import './linkedinDetails.container.scss';

type LinkedinListContainerPropsType = PropsFromRedux & RouteComponentProps & WithTranslation;

class LinkedinDetailsContainer extends Component<LinkedinListContainerPropsType> {
  public linkedinsDataManager: DataManager = null;
  public linkedinsQuery: Query = new Query()
    .select(['id', 'linkedInId', 'commentaryHtml', 'active'])
    .expand('medias');

  public constructor(props: LinkedinListContainerPropsType) {
    super(props);

    this.linkedinsDataManager = dataManagerService.buildDataManager(URL.ODATA.LINKEDIN_FILTERS);
  }

  public componentDidMount() {
    this.fetchLinkedins();
  }

  public render() {
    const {
      linkedins,
      userId,
      companyId,
      readMoreToggle,
      spinnerRequestMoreData,
      setNumPagesToDocument,
      setCurrentPageToDocument
    } = this.props;

    const items = linkedins/*.filter((item) => {
      return !item.medias.some((media) => media.type === 'PDF');
    })*/.map((item, index) => (
      <Linkedin
        key={item.id}
        linkedin={item as ILinkedin}
        isEven={(index % 2 == 0)}
        userId={userId}
        companyId={companyId}
        readMoreToggle={readMoreToggle}
        spinnerRequestMoreData={spinnerRequestMoreData}
        setNumPagesToDocument={setNumPagesToDocument}
        setCurrentPageToDocument={setCurrentPageToDocument}
      />
    ));

    return (
      <div>
        <div className='row'>
          <div className={'row centeredDiv'}>
            {items}
          </div>
        </div>
      </div>
    );
  }

  private fetchLinkedins() {
    const { fetchLinkedins } = this.props;

    fetchLinkedins(oDataService, this.linkedinsDataManager, this.buildQuery());
  }

  private buildQuery(): Query {
    const myRule: IMyRule = {
      condition: RuleCondition.AND,
      myRules: []
    };

    myRule.myRules.push({
      field: 'active',
      operator: RuleOperator.EQUAL,
      value: true
    });

    return queryBuilderService.buildQuery(this.linkedinsDataManager, myRule, this.linkedinsQuery.clone());
  }
}

const mapStateToProps = (state: RootState): ILinkedinDetailsContainerStateProps => ({
  linkedins: state.linkedinDetailsStore.linkedins,
  userId: state.currentUserStore.user.id,
  companyId: state.currentUserStore.company !== undefined && state.currentUserStore.company !== null ? state.currentUserStore.company.id : null
});

const mapDispatchToProps: ILinkedinDetailsContainerDispatchProps = {
  fetchLinkedins: linkedinDetailsStore.fetchLinkedins,
  readMoreToggle: linkedinDetailsStore.readMoreToggle,
  spinnerRequestMoreData: linkedinDetailsStore.spinnerRequestMoreData,
  setNumPagesToDocument: linkedinDetailsStore.setNumPagesToDocument,
  setCurrentPageToDocument: linkedinDetailsStore.setCurrentPageToDocument
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(
  withRouter,
  withTranslation(),
  connector
)(LinkedinDetailsContainer) as ComponentType;
